import React from 'react'
import { Col } from 'antd'
import type { ColProps } from 'antd'

interface CustomRowProps extends ColProps {
  children: React.ReactNode
  xs?: number
  lg?: number
}

const CustomCol: React.FC<CustomRowProps> = ({
  children,
  xs = 24,
  lg = 12,
  ...props
}) => <Col {...props} xs={xs} lg={lg}>{children}</Col>

export default CustomCol
